module.exports = __webpack_public_path__ + "static/fb07af886b76fa15e98c18a6d811f330e4eab6eaf154b5daee266f241956ecb5-3200427c8ac8d7985994e943296ed26f.jpeg";